import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';
import { Link } from "react-router-dom";
import logo from "../asset/img/onpr_logo.jpg";
import { Avatar } from '@mui/material';
import LanguageChanger from '../components/language_changer/language_changer';
import { useSelector } from 'react-redux';

const sections = [
  { title: { fr: 'Accueil', en: 'Home' }, url: '/' },
  { title: { fr: 'Informations', en: 'Informations' }, url: '/informations' },
  { title: { fr: "Annonces et Communiqués", en: "Announcements & News" }, url: '/annonce-communique' },
  { title: { fr: 'Services en ligne', en: 'Online service' }, url: '/online-service' },
  { title: { fr: 'Contacts', en: 'Contacts' }, url: '#web-footer', isId: true },
];

export default function Header() {
  const { currentLanguage } = useSelector((storeOf) => {
    return { currentLanguage: storeOf.nisys.currentLanguage };
  });

  return (
    <Toolbar
      sx={{
        borderBottom: 1,
        borderColor: 'green',
        backgroundColor: '#FFFFFF',
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 4,
      }}
    >
      {/* Left: Logo */}
      <Avatar
        alt="Logo de ONPR"
        src={logo}
        sx={{ width: { md: 80, xs: 50 }, height: { md: 80, xs: 50 } }}
      />

      {/* Center: Nav Links */}
      <div style={{ flexGrow: 1, textAlign: "center" }}>
        {sections.map((section) =>
          section.isId ? (
            <a
              key={section.url}
              href={section.url}
              style={{ color: "#1eb53a", margin: "0 20px", textDecoration: "none", fontWeight: 500 }}
            >
              {section.title[currentLanguage.code]}
            </a>
          ) : (
            <Link
              key={section.url}
              to={section.url}
              style={{ color: "#1eb53a", margin: "0 20px", textDecoration: "none", fontWeight: 500 }}
            >
              {section.title[currentLanguage.code]}
            </Link>
          )
        )}
      </div>

      {/* Right: Language Changer */}
      <LanguageChanger />
    </Toolbar>
  );
}
